import React from 'react'
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
} from '@mui/material';
import dayjs, { locale } from 'dayjs';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState } from 'react';
import { swalErrorBtn, swalLoading, swalSuccessBtn } from '../../helpers/swalHelper';
import InvoiceListApi from '../../service/invoice.api';
import 'dayjs/locale/th';

const ariaLabel = { 'aria-label': 'description' };

function TableUploadJV({ allowEdit, showData, statusETax }) {
      const [page, setPage] = useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(5);
      // allowEdit = false;
      const total = showData?.length || 0;

      const [isSending, setIsSending] = useState(false);

      const DATE_FORMAT = 'DD/MM/YYYY';

      const schema = () => {
          const baseSchema = {
            rows: yup.array().of(
              yup.object().shape({
                email: yup.string().nullable().test(
                  'is-valid-email',
                  'กรุณากรอกอีเมลในรูปแบบที่ถูกต้อง (กรอกหลายอีเมลได้โดยใช้จุลภาคคคั่น)',
                  (value) => {
                    if (value) {
                      const emails = value.split(',').map((email) => email.trim());
                      return emails.every((email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
                    }
                    return true;
                  },
                ),
                invoiceNumber: yup
                  .string()
                  .required('กรุณากรอกเลขที่ใบแจ้งหนี้'),
                taxId: yup
                  .string()
                  .test('customerCode', 'กรุณากรอก Tax Id หรือ Customer Code',
                    function (value) {
                      const { taxId, customerCode } = this.parent;
                      return !!taxId || !!customerCode;
                    }
                   ),
                customerCode: yup
                  .string()
                  .test('taxId', 'กรุณากรอก Customer Code หรือ Tax Id',
                    function (value) {
                      const { taxId, customerCode } = this.parent;
                      return !!taxId || !!customerCode;
                    }
                   ),
                soName: yup
                  .string()
                  .required('กรุณากรอกชื่อผู้ใช้บริการ'),
                address: yup
                  .string()
                  .required('กรุณากรอกที่อยู่'),
                zipCode: yup
                  .string()
                  .required('กรุณากรอกรหัสไปรษณีย์'),
                invoiceStartDate: yup
                  .string()
                  .required('กรุณากรอกวันที่ใบแจ้งหนี้'),
                invoiceDueDate: yup
                  .string()
                  .required('กรุณากรอกวันครบกำหนดชำระเงิน'),
                periodStartDate: yup
                  .string()
                  .required('กรุณากรอกวันที่เริ่มต้นระยะเวลา'),
                periodEndDate: yup
                  .string()
                  .required('กรุณากรอกวันที่สิ้นสุดระยะเวลา'),
                branchName: yup
                  .string()
                  .required('กรุณากรอกสาขา'),
                soNumber: yup
                  .string()
                  .required('กรุณากรอกเลข SO'),
                totalAmount: yup
                  .number()
                  .typeError('กรุณากรอกจำนวนเงินทั้งหมด')
                  .required('กรุณากรอกจำนวนเงินทั้งหมด'),
                amountVat: yup
                  .number()
                  .typeError('กรุณากรอกจำนวนเงินภาษีมูลค่าเพิ่ม')
                  .required('กรุณากรอกจำนวนเงินภาษีมูลค่าเพิ่ม'),
                grandTotal: yup
                  .number()
                  .typeError('กรุณากรอกยอดรวมทั้งหมด')
                  .moreThan(0, 'ยอดรวมทั้งหมดต้องมากว่า 0')
                  .required('กรุณากรอกยอดรวมทั้งหมด'),
                descriptionList: yup.array().of(
                  yup.object().shape({
                    description: yup.string().required('กรุณากรอกรายละเอียด'),
                    quantity: yup.string().required('กรุณากรอกจำนวน'),
                    unitPrice: yup.string().required('กรุณากรอกราคาต่อหน่วย'),
                    amount: yup.string().required('กรุณากรอกจำนวนเงิน'),
                  })
                ),
              }),
            ),
          };

          return yup.object().shape(baseSchema);
        };

        const {
          register,
          handleSubmit,
          formState: { errors },
          setValue,
          trigger,
          control,
        } = useForm({
          resolver: yupResolver(schema()),
        });

        const { fields, append, remove } = useFieldArray({
          control,
          name: 'rows',
        });

        const onSubmit = async (item) => {
          // console.log('item', item);

          if (isSending) return;
          setIsSending(true);

          swalLoading({title: 'กำลังอัปโหลดข้อมูล...'});

          try {
            const updatedData = item.rows.map((row) => ({
              ...row,
            }));

            const data = await InvoiceListApi.uploadInvoiceApi(updatedData);

            if (data.status_message === 'create success') {
              // setOpenDialog(true);
              swalSuccessBtn({
                title: 'อัปโหลดข้อมูลสำเร็จ'
              }).then((result) => {
                window.location.reload();
              });
            }
          } catch (error) {
            console.log(error);
            swalErrorBtn({title: 'อัปโหลดข้อมูลไม่สำเร็จ'});
          } finally {
            setIsSending(false);
          }
        };

        const cancel = () => {
          swalErrorBtn({
            title: 'ยกเลิกการอัปโหลดข้อมูล',
            icon: 'warning'
          }).then((result) => {
            window.location.reload();
          });
        };

        React.useEffect(() => {
          if (showData) {
            // Reset fields before appending new ones
            remove(); // Remove all current rows in the form
            showData.forEach((row) => {
              append({ ...row }); // Append new rows
            });
          }
        }, [showData, append, remove, setValue]);

    return (
      <div>
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div style={{ width: '100%', overflowX: 'auto', maxWidth: '90vw', }}>
                  <TableContainer component={Paper} style={{ minWidth: 650, width: 'max-content', maxWidth: '100%', }}>
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="simple table"
                        >
                          <TableHead>
                              <TableRow>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>เลข SO</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>เลขที่ใบแจ้งหนี้</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>เลขประจำตัวผู้เสียภาษี</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>ชื่อผู้ใช้บริการ</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 150 }}>ที่อยู่</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>รหัสไปรษณีย์</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>รหัสลูกค้า</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>ชื่อสาขา</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>วันที่ใบแจ้งหนี้</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>วันครบกำหนดชำระเงิน</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>รายละเอียด สินค้า บริการ</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>จำนวน</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>ราคาต่อหน่วย</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>จำนวนเงิน</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>Remark</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>วันที่เริ่มต้นระยะเวลา</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>วันที่สิ้นสุดระยะเวลา</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>จำนวนเงินก่อนภาษีมูลค่าเพิ่ม</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>จำนวนเงินภาษีมูลค่าเพิ่ม</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>ยอดรวมทั้งหมด (ยอดชำระ)</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>อีเมล</TableCell>
                                  <TableCell align="center" sx={{ minWidth: 120 }}>ลบรายการ</TableCell>
                              </TableRow>
                          </TableHead>
                          <TableBody>
                            {fields.slice(page * rowsPerPage,Math.min(fields.length, (page + 1) * rowsPerPage),).map((row, index) => {
                              const globalIndex = page * rowsPerPage + index;
                              const descList = row.descriptionList || [];
                              // console.log("descList", descList)
                              return descList.map((desc, descIdx) => (
                              <TableRow key={`${globalIndex}-${descIdx}`}>
                                {descIdx === 0 && ( 
                                  <>
                                    {/* เลข SO */}
                                    {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                          <TextField
                                              variant="standard"
                                              {...register(`rows.${globalIndex}.soNumber`)}
                                              defaultValue={row.soNumber}
                                              inputProps={{
                                              style: { textAlign: 'center' },
                                              }}
                                              error={!!errors?.rows?.[globalIndex]?.soNumber}
                                              helperText={
                                              errors?.rows?.[globalIndex]?.soNumber?.message
                                              }
                                          />
                                      </TableCell>
                                    ) : (
                                      <TableCell align="center" rowSpan={descList.length}>
                                          {row.soNumber || '-'}
                                      </TableCell>
                                    )}
                                  
                                  {/* เลขที่ใบแจ้งหนี้ */}
                                  {allowEdit ? (
                                    <TableCell align='center' rowSpan={descList.length}>
                                      <TextField
                                      variant="standard"
                                      {...register(`rows.${globalIndex}.invoiceNumber`)}
                                      defaultValue={row.invoiceNumber}
                                      inputProps={{style: { textAlign: 'center' },}}
                                      error={!!errors?.rows?.[globalIndex]?.invoiceNumber}
                                      helperText={
                                        errors?.rows?.[globalIndex]?.invoiceNumber?.message
                                      }
                                      />
                                    </TableCell>
                                  ) : (
                                    <TableCell align='center' rowSpan={descList.length}>
                                      {row.soNumber || '-'}
                                    </TableCell>
                                  )}
                                  {/* เลขประจำตัวผู้เสียภาษี */}
                                  {allowEdit ? (
                                        <TableCell rowSpan={descList.length}>
                                          <TextField
                                          variant="standard"
                                          {...register(`rows.${globalIndex}.taxId`)}
                                          defaultValue={row.taxId}
                                          inputProps={{
                                              style: { textAlign: 'center' },
                                          }}
                                          error={!!errors?.rows?.[globalIndex]?.taxId}
                                          helperText={
                                              errors?.rows?.[globalIndex]?.taxId?.message
                                          }
                                          />
                                      </TableCell>
                                  ) : (
                                      <TableCell rowSpan={descList.length}>
                                          {row.taxId || '-'}
                                      </TableCell>
                                  )}
                                  {/* ชื่อผู้ใช้บริการ */}
                                  {allowEdit ? (
                                      <TableCell align="center" rowSpan={descList.length}>
                                        <TextareaAutosize
                                          minRows={1}
                                          defaultValue={row.soName}
                                          {...register(`rows.${globalIndex}.soName`)}
                                          aria-label={ariaLabel['aria-label']}
                                          style={{
                                            textAlign: 'left',
                                            width: '120px',
                                            resize: 'none',
                                            border: 'none',
                                            borderBottom: !!errors?.rows?.[globalIndex]?.soName
                                              ? '1px solid red'
                                              : '1px solid #AFAFAF',
                                            paddingBottom: '4px',
                                            outline: 'none',
                                            background: 'none',
                                          }}
                                        />
                                        {!!errors?.rows?.[globalIndex]?.soName && (
                                          <p
                                            style={{
                                              color: 'red',
                                              fontSize: '12px',
                                              marginTop: '4px',
                                            }}
                                          >
                                            {errors?.rows?.[globalIndex]?.soName?.message}
                                          </p>
                                        )}
                                      </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        {row.soName || '-'}
                                    </TableCell>
                                  )}
                                  {/* ที่อยู่ */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextareaAutosize
                                          minRows={1}
                                          defaultValue={row.address}
                                          {...register(`rows.${globalIndex}.address`)}
                                          aria-label={ariaLabel['aria-label']}
                                          style={{
                                            textAlign: 'left',
                                            width: '120px',
                                            resize: 'none',
                                            border: 'none',
                                            borderBottom: !!errors?.rows?.[globalIndex]?.address
                                              ? '1px solid red'
                                              : '1px solid #AFAFAF',
                                            paddingBottom: '4px',
                                            outline: 'none',
                                            background: 'none',
                                          }}
                                        />
                                        {!!errors?.rows?.[globalIndex]?.address && (
                                          <p
                                            style={{
                                              color: 'red',
                                              fontSize: '12px',
                                              marginTop: '4px',
                                            }}
                                          >
                                            {errors?.rows?.[globalIndex]?.address?.message}
                                          </p>
                                        )}
                                      </TableCell>
                                  ) : (
                                      <TableCell align="center" rowSpan={descList.length}>
                                          {row.address || '-'}
                                      </TableCell>
                                  )}

                                  {/* รหัสไปรษณีย์ */}
                                  {allowEdit ? (
                                    <TableCell rowSpan={descList.length}>
                                        <TextField
                                          variant="standard"
                                          {...register(`rows.${globalIndex}.zipCode`)}
                                          defaultValue={row.zipCode}
                                          inputProps={{
                                              style: { textAlign: 'center' },
                                          }}
                                          error={!!errors?.rows?.[globalIndex]?.zipCode}
                                          helperText={
                                              errors?.rows?.[globalIndex]?.zipCode?.message
                                          }
                                          />
                                      </TableCell>
                                  ) : (
                                      <TableCell align="center" rowSpan={descList.length}>
                                          {row.zipCode || '-'}
                                      </TableCell>
                                  )}
                                  
                                  {/* รหัสลูกค้า */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.customerCode`)}
                                            defaultValue={row.customerCode}
                                            inputProps={{
                                            style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.customerCode}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.customerCode?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        {row.customerCode || '-'}
                                    </TableCell>
                                  )}

                                  {/* สาขา */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.branchName`)}
                                            defaultValue={row.branchName}
                                            inputProps={{
                                            style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.branchName}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.branchName?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        {row.branchName || '-'}
                                    </TableCell>
                                  )}

                                  {/* วันที่ใบแจ้งหนี้ */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Controller
                                            name={`rows.${globalIndex}.invoiceStartDate`}
                                            control={control}
                                            render={({ field }) => (
                                                <DatePicker
                                                // {...console.log('field_start', field.value)}
                                                value={
                                                    field.value ? dayjs(field.value, DATE_FORMAT) : null
                                                }
                                                onChange={(newValue) => {
                                                    field.onChange(
                                                    newValue
                                                        ? newValue
                                                        : null,
                                                    );
                                                }}
                                                inputFormat={DATE_FORMAT}
                                                renderInput={(params) => (
                                                    <TextField
                                                    {...params}
                                                    variant="standard"
                                                    error={
                                                        !!errors?.rows?.[globalIndex]
                                                        ?.invoiceStartDate
                                                    }
                                                    helperText={
                                                        errors?.rows?.[globalIndex]
                                                        ?.invoiceStartDate?.message
                                                    }
                                                    />
                                                )}
                                                />
                                            )}
                                            />
                                        </LocalizationProvider>
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                      {/* {dayjs(row.datesale).locale('th').format('DD MMMM YYYY') || '-'} */}
                                      {row.invoiceStartDate || '-'}
                                    </TableCell>
                                  )}

                                  {/* วันครบกำหนดชำระเงิน */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Controller
                                            name={`rows.${globalIndex}.invoiceDueDate`}
                                            control={control}
                                            render={({ field }) => (
                                                <DatePicker
                                                // {...console.log('field_start', field.value)}
                                                value={
                                                    field.value ? dayjs(field.value, DATE_FORMAT) : null
                                                }
                                                onChange={(newValue) => {
                                                    field.onChange(
                                                    newValue
                                                        ? newValue
                                                        : null,
                                                    );
                                                }}
                                                inputFormat={DATE_FORMAT}
                                                renderInput={(params) => (
                                                    <TextField
                                                    {...params}
                                                    variant="standard"
                                                    error={
                                                        !!errors?.rows?.[globalIndex]
                                                        ?.invoiceDueDate
                                                    }
                                                    helperText={
                                                        errors?.rows?.[globalIndex]
                                                        ?.invoiceDueDate?.message
                                                    }
                                                    />
                                                )}
                                                />
                                            )}
                                            />
                                        </LocalizationProvider>
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                      {/* {dayjs(row.datesale).locale('th').format('DD MMMM YYYY') || '-'} */}
                                      {row.invoiceDueDate || '-'}
                                    </TableCell>
                                  )}

                                  </>
                                  )}

                                  {/* รายละเอียด สินค้า บริการ */}
                                  {allowEdit ? (
                                    <TableCell align="center">
                                      <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.descriptionList.${descIdx}.description`)}
                                            defaultValue={row.description}
                                            inputProps={{
                                            style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.description}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.description?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center">
                                        {desc.description || '-'}
                                    </TableCell>
                                  )}

                                  {/* จำนวน */}
                                  {allowEdit ? (
                                    <TableCell align="center">
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.descriptionList.${descIdx}.quantity`)}
                                            defaultValue={row.quantity}
                                            inputProps={{
                                                type: 'number',
                                                min: 0,
                                                style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.quantity}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.quantity?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center">
                                        {desc.quantity || '-'}
                                    </TableCell>
                                  )}

                                  {/* ราคาต่อหน่วย */}
                                  {allowEdit ? (
                                    <TableCell align="center">
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.descriptionList.${descIdx}.unitPrice`)}
                                            defaultValue={row.unitPrice}
                                            inputProps={{
                                                type: 'number',
                                                step: '0.01',
                                                min: 0,
                                                style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.unitPrice}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.unitPrice?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center">
                                        {desc.unitPrice || '-'}
                                    </TableCell>
                                  )}

                                  {/* จำนวนเงิน */}
                                  {allowEdit ? (
                                    <TableCell align="center">
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.descriptionList.${descIdx}.amount`)}
                                            defaultValue={row.amount}
                                            inputProps={{
                                                type: 'number',
                                                step: '0.01',
                                                min: 0,
                                                style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.amount}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.descriptionList?.[descIdx]?.amount?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center">
                                        {desc.amount || '-'}
                                    </TableCell>
                                  )}

                                  {descIdx === 0 && ( 
                                  <>
                                  {/* Remark */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextareaAutosize
                                          minRows={1}
                                          defaultValue={row.remark}
                                          {...register(`rows.${globalIndex}.remark`)}
                                          aria-label={ariaLabel['aria-label']}
                                          style={{
                                            textAlign: 'left',
                                            width: '120px',
                                            resize: 'none',
                                            border: 'none',
                                            borderBottom: !!errors?.rows?.[globalIndex]?.remark
                                              ? '1px solid red'
                                              : '1px solid #AFAFAF',
                                            paddingBottom: '4px',
                                            outline: 'none',
                                            background: 'none',
                                          }}
                                        />
                                        {!!errors?.rows?.[globalIndex]?.remark && (
                                          <p
                                            style={{
                                              color: 'red',
                                              fontSize: '12px',
                                              marginTop: '4px',
                                            }}
                                          >
                                            {errors?.rows?.[globalIndex]?.remark?.message}
                                          </p>
                                        )}
                                      </TableCell>
                                  ) : (
                                      <TableCell align="center" rowSpan={descList.length}>
                                          {row.remark || '-'}
                                      </TableCell>
                                  )}
                                  {/* วันที่เริ่มต้นระยะเวลา */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Controller
                                            name={`rows.${globalIndex}.periodStartDate`}
                                            control={control}
                                            render={({ field }) => (
                                                <DatePicker
                                                // {...console.log('field_start', field.value)}
                                                value={
                                                    field.value ? dayjs(field.value, DATE_FORMAT) : null
                                                }
                                                onChange={(newValue) => {
                                                    field.onChange(
                                                    newValue
                                                        ? newValue
                                                        : null,
                                                    );
                                                }}
                                                inputFormat={DATE_FORMAT}
                                                renderInput={(params) => (
                                                    <TextField
                                                    {...params}
                                                    variant="standard"
                                                    error={
                                                        !!errors?.rows?.[globalIndex]
                                                        ?.periodStartDate
                                                    }
                                                    helperText={
                                                        errors?.rows?.[globalIndex]
                                                        ?.periodStartDate?.message
                                                    }
                                                    />
                                                )}
                                                />
                                            )}
                                            />
                                        </LocalizationProvider>
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                      {/* {dayjs(row.datesale).locale('th').format('DD MMMM YYYY') || '-'} */}
                                      {row.periodStartDate || '-'}
                                    </TableCell>
                                  )}
                                  
                                  {/* วันที่สิ้นสุดระยะเวลา */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Controller
                                            name={`rows.${globalIndex}.periodEndDate`}
                                            control={control}
                                            render={({ field }) => (
                                                <DatePicker
                                                // {...console.log('field_start', field.value)}
                                                value={
                                                    field.value ? dayjs(field.value, DATE_FORMAT) : null
                                                }
                                                onChange={(newValue) => {
                                                    field.onChange(
                                                    newValue
                                                        ? newValue
                                                        : null,
                                                    );
                                                }}
                                                inputFormat={DATE_FORMAT}
                                                renderInput={(params) => (
                                                    <TextField
                                                    {...params}
                                                    variant="standard"
                                                    error={
                                                        !!errors?.rows?.[globalIndex]
                                                        ?.periodEndDate
                                                    }
                                                    helperText={
                                                        errors?.rows?.[globalIndex]
                                                        ?.periodEndDate?.message
                                                    }
                                                    />
                                                )}
                                                />
                                            )}
                                            />
                                        </LocalizationProvider>
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                      {/* {dayjs(row.datesale).locale('th').format('DD MMMM YYYY') || '-'} */}
                                      {row.periodEndDate || '-'}
                                    </TableCell>
                                  )}

                                  {/* จำนวนเงินทั้งหมด */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.totalAmount`)}
                                            defaultValue={row.totalAmount}
                                            inputProps={{
                                                type: 'number',
                                                step: '0.01',
                                                min: 0,
                                                style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.totalAmount}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.totalAmount?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        {row.totalAmount || '-'}
                                    </TableCell>
                                  )}
                                  {/* จำนวนเงินภาษีมูลค่าเพิ่ม */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.amountVat`)}
                                            defaultValue={row.amountVat}
                                            inputProps={{
                                                type: 'number',
                                                step: '0.01',
                                                min: 0,
                                                style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.amountVat}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.amountVat?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        {row.amountVat || '-'}
                                    </TableCell>
                                  )}
                                  {/* ยอดรวมทั้งหมด (ยอดชำระ) */}
                                  {allowEdit ? (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        <TextField
                                            variant="standard"
                                            {...register(`rows.${globalIndex}.grandTotal`)}
                                            defaultValue={row.grandTotal}
                                            inputProps={{
                                                type: 'number',
                                                step: '0.01',
                                                min: 0,
                                                style: { textAlign: 'center' },
                                            }}
                                            error={!!errors?.rows?.[globalIndex]?.grandTotal}
                                            helperText={
                                            errors?.rows?.[globalIndex]?.grandTotal?.message
                                            }
                                        />
                                    </TableCell>
                                  ) : (
                                    <TableCell align="center" rowSpan={descList.length}>
                                        {row.grandTotal || '-'}
                                    </TableCell>
                                  )}

                                  {/* อีเมลล์ */}
                                  {allowEdit ? (
                                      <TableCell align="center" rowSpan={descList.length}>
                                          <TextareaAutosize
                                              minRows={1}
                                              defaultValue={row.email}
                                              {...register(`rows.${globalIndex}.email`)}
                                              aria-label={ariaLabel['aria-label']}
                                              style={{
                                              textAlign: 'left',
                                              width: '120px',
                                              resize: 'none',
                                              border: 'none',
                                              borderBottom: !!errors?.rows?.[globalIndex]?.email
                                                  ? '1px solid red'
                                                  : '1px solid #AFAFAF',
                                              paddingBottom: '4px',
                                              outline: 'none',
                                              background: 'none',
                                              }}
                                          />
                                          {!!errors?.rows?.[globalIndex]?.email && (
                                              <p
                                              style={{
                                                  color: 'red',
                                                  fontSize: '12px',
                                                  marginTop: '4px',
                                              }}
                                              >
                                              {errors?.rows?.[globalIndex]?.email?.message}
                                              </p>
                                          )}
                                      </TableCell>
                                  ) : (
                                      <TableCell align="center" rowSpan={descList.length}>
                                        {row.email || '-'}
                                      </TableCell>
                                  )}

                                  {/* Action */}
                                  <TableCell align="center" rowSpan={descList.length}>
                                    <IconButton
                                      onClick={() => remove(globalIndex)}
                                      aria-label="delete"
                                      color="error"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </TableCell>
                                  
                                  </>
                                  )}

                              </TableRow>
                              ));
                              // );
                            })}
                          </TableBody>
                      </Table>
                  </TableContainer>
                  {/* </Paper> */}

                  <TablePagination
                    sx={{
                      width: 'auto',
                      marginRight: '8px',
                      '& .MuiTypography-caption': { display: 'none' },
                    }}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    rowsPerPage={rowsPerPage}
                    page={page}
                    count={total}
                    labelRowsPerPage="Rows"
                    onPageChange={(event, newPage) => {
                      setPage(newPage);
                    }}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                  <div className="mt-7 flex justify-end">
                    <div className="mr-3">
                      {showData && (
                        <Button type="submit" variant="contained">
                          <div className="text-white">ยืนยันอัปโหลดข้อมูล</div>
                        </Button>
                      )}
                    </div>
                    <div>
                      <Button onClick={cancel} variant="outlined" color="error">
                        ยกเลิการอัปโหลด
                      </Button>
                    </div>
                  </div>
              </div>
          </form>
      </div>
    )
}

export default TableUploadJV
